import Vue from 'vue';

// initial state
const state = () => ({
    releaseVersion: '',
})

// getters
const getters = {

    getStateDomainData(state) {
        Vue.nextTick(() => {
            let jsonState = JSON.stringify(state);
            localStorage.setItem('@datadrive:domain', jsonState);
        });
        return state;
    },
    getReleaseVersion(state) {
        return state.releaseVersion;
    },

}

// actions
const actions = {

}

// mutations
const mutations = {

    setStateDomainData(state, payload)
    {
        for (var [key, value] of Object.entries(payload)) {
            state[key] = value;
        }

        let jsonState = JSON.stringify(payload);
        localStorage.setItem('@datadrive:domain', jsonState);

        Vue.nextTick(() => {
            let jsonState = JSON.stringify(payload);
            localStorage.setItem('@datadrive:domain', jsonState);
        });
    },

    setReleaseVersion(state, payload) {
        state.releaseVersion = payload;
    },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
